import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { Criterios } from "../models/Maestras/maestras.model";

export const useGestionCriterios = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    const [datosActuales, setDatosActuales] = useState<Criterios[]>([])
    const [criterios, setCriterios] = useState<Criterios[]>([])
    const obtenerCriterios = async() => {
        try {
            const criterios = await apiMaestras.obtenerCriterios();
            setCriterios(criterios);
            setDatosActuales(criterios)
        } catch (error) {
            console.log(error);
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        obtenerCriterios,
        criterios,
        datosActuales,
        setDatosActuales
    } 
}
